import { ApiClient } from '@webapp/core/services/ApiClient'
import { ApprovalRoutingRepository } from './ApprovalRoutingRepository'

export const approvalRoutingRepository = new ApprovalRoutingRepository({
  httpClient: ApiClient,
})
